"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Usage(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { height: "".concat(height), viewBox: '0 0 106 106', className: "".concat(className), width: "".concat(width) },
        React.createElement("g", { filter: 'url(#filter0_d)' },
            React.createElement("path", { d: 'M20.702 6.858C31.468 4.286 42.234 3 53 3c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0111.844 11.844C99.714 29.468 101 40.234 101 51c0 10.766-1.286 21.532-3.858 32.298a16 16 0 01-11.844 11.844C74.532 97.714 63.766 99 53 99c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 018.858 83.298C6.286 72.532 5 61.766 5 51c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0120.702 6.858z', fill: '#883D20' })),
        React.createElement("path", { d: 'M27 31.818v30.988a3.524 3.524 0 003.532 3.526H75.47A3.527 3.527 0 0079 62.806V31.818a3.531 3.531 0 00-3.53-3.528H30.531A3.527 3.527 0 0027 31.818zM77.677 47.31a2.097 2.097 0 11-4.195 0 2.097 2.097 0 014.195 0zm-5.032-15.45v30.902H30.243V31.859h42.402z', fill: '#fff' }),
        React.createElement("path", { d: 'M62.351 51.259h-.176a1.859 1.859 0 00-1.858 1.854v1.658h-.228v-1.658a1.859 1.859 0 00-1.856-1.854h-.182a1.857 1.857 0 00-1.854 1.854v1.658h-.23v-1.658a1.857 1.857 0 00-1.854-1.854h-.184c-1.02 0-1.854.832-1.854 1.854v1.658h-.12V44.177a1.866 1.866 0 00-1.867-1.866l-.181-.001a1.867 1.867 0 00-1.863 1.867v16.209c-.498-.562-.936-1.135-1.337-1.652-.892-1.154-1.593-2.068-2.385-2.25-.879-.21-1.691.084-2.082.718-.367.603-.311 1.433.153 2.333 1.016 1.943 5.897 10.479 5.9 10.479.386.934 2.09 3.986 7.823 3.986v-.204l.006.204c4.17 0 6.145-1.968 7.068-3.618.996-1.782 1.012-3.538 1.012-3.614V53.113a1.853 1.853 0 00-1.851-1.854z', fill: '#fff' }),
        React.createElement("defs", null,
            React.createElement("filter", { colorInterpolationFilters: 'sRGB', filterUnits: 'userSpaceOnUse', height: 106, id: 'filter0_d', width: 106, x: 0, y: 0 },
                React.createElement("feFlood", { floodOpacity: 0, result: 'BackgroundImageFix' }),
                React.createElement("feColorMatrix", { in: 'SourceAlpha', result: 'hardAlpha', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' }),
                React.createElement("feOffset", { dy: 2 }),
                React.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
                React.createElement("feColorMatrix", { values: '0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0.5 0' }),
                React.createElement("feBlend", { in2: 'BackgroundImageFix', result: 'effect1_dropShadow' }),
                React.createElement("feBlend", { in: 'SourceGraphic', in2: 'effect1_dropShadow', result: 'shape' })))));
}
Usage.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Usage.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Usage;
